import './axios-augment';
import type { AxiosInstance } from 'axios';
import type { ServerReachabilityMonitor } from './monitor';

export function attachReachabilityToAxios(
  client: AxiosInstance,
  monitor: ServerReachabilityMonitor,
): () => void {
  const id = client.interceptors.response.use(
    (response) => {
      if (!response.config.servedFromLocal) {
        monitor.reportSuccess();
      }
      return response;
    },
    (error) => {
      monitor.reportFailure(error);
      return Promise.reject(error);
    },
  );
  return () => client.interceptors.response.eject(id);
}
